import React from 'react';

import FeeTableRow from './FeeTableRow';

import Fee from '../../Entities/Fee';

import './FeeTable.scss';

class FeeTable extends React.Component {
  _onFeeChange(ident) {
    return value => {
      this.props.onFeeChange(ident, value);
    };
  }


  handleAddFeeClick = () => {
    const {
      feeType
    } = this.props;

    this._onFeeChange(null)(new Fee(feeType));
  }


  render() {
    const {
      feeRows,
      inputId,
      entityLabel = 'Fee',
      allowAdd,
      editMode,
      disabledMode
    } = this.props;

    return (
      <div className="parkchirp--fee-table">
        <header className="parkchirp--fee-table--header">
          <div className={`parkchirp--fee-table--cell` +
            ` parkchirp--fee-table--start-date-column`}>
            <span className="parkchirp--access-device-table--column-heading">Effective Date</span>
          </div>
          <div className={`parkchirp--fee-table--cell` +
            ` parkchirp--fee-table--net-amount-column`}>
            <span className="parkchirp--access-device-table--column-heading">Net {entityLabel}</span>
          </div>
          <div className={`parkchirp--fee-table--cell` +
            ` parkchirp--fee-table--tax-1-amount-column`}>
            <span className="parkchirp--access-device-table--column-heading">Tax #1</span>
          </div>
          <div className={`parkchirp--fee-table--cell` +
            ` parkchirp--fee-table--tax-2-amount-column`}>
            <span className="parkchirp--access-device-table--column-heading">Tax #2</span>
          </div>
          <div className={`parkchirp--fee-table--cell` +
            ` parkchirp--fee-table--tax-3-amount-column`}>
            <span className="parkchirp--access-device-table--column-heading">Tax #3</span>
          </div>
          <div className={`parkchirp--fee-table--cell` +
            ` parkchirp--fee-table--tax-4-amount-column`}>
            <span className="parkchirp--access-device-table--column-heading">Tax #4</span>
          </div>
          <div className={`parkchirp--fee-table--cell` +
            ` parkchirp--fee-table--gross-amount-column`}>
            <span className="parkchirp--access-device-table--column-heading">Gross {entityLabel}</span>
          </div>
        </header>
        <div className="parkchirp--fee-table--body">
          {feeRows.map(feeRow => {
            return (
              <FeeTableRow inputId={inputId}
                key={feeRow.ident}
                ident={feeRow.ident}
                fee={feeRow.data}
                onValueChange={this._onFeeChange(feeRow.ident)}
                editMode={editMode}
                disabledMode={disabledMode}
              />
            );
          })}
        </div>
        {(allowAdd) &&
          <footer className="parkchirp--fee-table--footer">
            <div className="parkchirp--fee-table--cell">
              <button type="button"
                className="parkchirp--button-as-link"
                onClick={this.handleAddFeeClick}>
                Add {entityLabel}
              </button>
            </div>
          </footer>
        }
      </div>
    );
  }
}
export default FeeTable;
